require('./accountsBuyAmazonGiftCardStep1.scss');
require('./accountsBuyAmazonGiftCardStep1.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { AmountInput } = require('commonsComponents/amountInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@helper
const { formatText, getLanguage, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const currencyHelper = require('utilities/currencyHelper');
const { formatCurrency, formatAmount } = require('utilities/currencyHelper');
//@constants
const { EURO_TEXT } = require('constants/index');
const {
    AMAZON_GIFT_CARD_MAX_AMOUNT,
    AMAZON_GIFT_CARD_MIN_AMOUNT,
    AMAZON_GIFT_CARD_MAX_FRACTION_LENGTH,
    AMAZON_GIFT_CARD_MAX_INTEGER_LENGTH
} = require('constants/accountAmazonGiftCard');
const language = getLanguage();
const { 
    AMAZON_GIFT_CARD_AMOUNT_ERROR,
    AMAZON_GIFT_CARD_HIRING_IMPORTE,
    AMAZON_GIFT_CARD_TIPO_PROCESS,
    AMAZON_PROMOCIONES_STEP_ONE, 
} = require('constants/tagging');
// @ components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const { OKCheckbox } = require('commonsComponents/OKCheckbox')
//@utils
const {
    recordLinkV2,
    recordPath
} = require("utilities/tagging");

class AccountsBuyAmazonGiftCardStep1 extends React.Component {

    constructor(props){
        super(props);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.setChangedAmount = this.setChangedAmount.bind(this);
        this.handleAgreementCheckboxChange = this.handleAgreementCheckboxChange.bind(this);
    }

    componentDidMount() {
        const {
            setAccount,
            immAccounts,
            immStep,
            setAccountAvailableBalance,
            initialAccount
        } = this.props;

        if (!immStep.get('accountSelected') && !!initialAccount) {
            const isInactiveAccount = initialAccount.get('isInactiveAccount');
            if(!isInactiveAccount) {
                const initialAccountId = initialAccount.get('accountId');
                const accountAvailableBalance = immAccounts.getIn([initialAccountId,'balances','availableBalance','amount']);
                setAccount(initialAccountId);
                setAccountAvailableBalance(accountAvailableBalance);
            }
        }
        recordPath(AMAZON_PROMOCIONES_STEP_ONE, '', AMAZON_GIFT_CARD_TIPO_PROCESS, "paso 1");
    }

    handleAgreementCheckboxChange(evt) {
        const { handleAgreementCheckboxChange } = this.props;
        handleAgreementCheckboxChange(evt.target.checked);
    }

    buildPrecontractualMailInfo() {
        const {
            immProfile,
            immPreContractualMail,
            requestProfile,
            sendPreContractualMail,
            immStep,
        } = this.props;

        const contractName = formatText('amazonGiftCard-pageTitle');
        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const profileError = immProfile.get('error');
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('amazonGiftCard-step1CheckboxErrorMsg');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const urlLinkTermsAndConditions = "https://www.amazon.es/cheques-regalo-condiciones";
        const agreementLabel = (
            <FormattedText
                value="amazonGiftCard-step1CheckboxText"
                injectedStrings={[urlLinkTermsAndConditions]}
            />
        );

        const sendMailParams = {
            productName: "Amazon Gift Card"
        };

        return (
            <div className="accounts-buy-amazon-gift-card-step1__pre-contractual-info">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                    showLegalText={false}
                />
                <div className="accounts-buy-amazon-gift-card-step1__checkbox-container">
                    <OKCheckbox
                        idName="accountsBuyAmazonGiftCardAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={this.handleAgreementCheckboxChange}
                        value={agreementChecked}
                        disabled={!hasBeenEmailSent}
                    />
                </div>
            </div>
        )
    }

    handleAccountFromChange(accountId) {
        const {
            setAccount,
            immAccounts,
            setAccountAvailableBalance,
            immStep
        } = this.props;

        setAccount(accountId);
        setAccountAvailableBalance(immAccounts.getIn([accountId,'balances','availableBalance','amount']));

        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES_STEP_ONE,
            accionEvento: "seleccionar cuenta",
            etiquetaEvento: immStep.get('accountSelected')
        });
        recordLinkV2(customData);
    }

    handleFocus() {
        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES_STEP_ONE,
            accionEvento: "clickTextBox",
            etiquetaEvento: AMAZON_GIFT_CARD_HIRING_IMPORTE
        });
        recordLinkV2(customData);
    }

    setChangedAmount(amount) {
        const {
            setAmount,
            setGiftVoucherAmount,
            promotionalPercentage
        } = this.props;
        const giftVoucherAmount = Math.round(amount * (100 - promotionalPercentage)) / 100;
        setAmount(amount);
        setGiftVoucherAmount(Number(giftVoucherAmount));
    }

    render(){
        const {
            immAccounts,
            accountsIndexes,
            immStep,
            immProfile,
            isInactiveAccountsEnabled,
            promotionalPercentage,
            amazonGiftCards
        } = this.props;
        let email = PersonalDataHelper.getEmail(immProfile) || formatText('buyAmazonGiftCard-noEmailText');
        const currency = currencyHelper.formatCurrency(EURO_TEXT);

        let selectedAccount = immStep.get('accountSelected');
        let accountAvailableBalance = immStep.get('accountAvailableBalance');
        let cardRemainingBalance = amazonGiftCards.get('remainingBalance');
        const maxInputAmount = Math.min(AMAZON_GIFT_CARD_MAX_AMOUNT, cardRemainingBalance);

        let accountDropdownErrorMessage;
        let accountDropdownError = false;
        if (selectedAccount && accountAvailableBalance <= 0) {
            accountDropdownError = true;
            accountDropdownErrorMessage = formatText('buyAmazonGiftCard-errorNoBalanceInAccountTobuyGiftCard');
        }

        const amazonGiftCardMinAmount = currencyHelper.getFormattedString({ amount: AMAZON_GIFT_CARD_MIN_AMOUNT, currency });
        const amountLesserMinimum = immStep.get('amount') < AMAZON_GIFT_CARD_MIN_AMOUNT;
        const amountGreaterAccountBalance = immStep.get('giftVoucherAmount') > accountAvailableBalance && immStep.get('accountSelected');
        const amountGreaterCardRemainingBalance = immStep.get('amount') > cardRemainingBalance && immStep.get('amountisDirty');
        let amountErrorMessage = formatText('buyAmazonGiftCard-errorMinimumAmountCheck', [amazonGiftCardMinAmount]);

        if (amountGreaterAccountBalance) {
            amountErrorMessage = formatText('buyAmazonGiftCard-errorAmountExceedsAvailableBalance');
            const customData = ({
                categoriaEvento: AMAZON_PROMOCIONES_STEP_ONE,
                accionEvento: "superado saldo disponible",
                etiquetaEvento: AMAZON_GIFT_CARD_AMOUNT_ERROR
            });
            recordLinkV2(customData);
        } else if ( amountGreaterCardRemainingBalance) {
            amountErrorMessage = formatText('buyAmazonGiftCard-errorMaximumAmountCheck', [cardRemainingBalance]);
            const customData = ({
                categoriaEvento: AMAZON_PROMOCIONES_STEP_ONE,
                accionEvento: "superado importe maximo",
                etiquetaEvento: AMAZON_GIFT_CARD_AMOUNT_ERROR
            });
            recordLinkV2(customData);
        }

        const amountError = (amountLesserMinimum || amountGreaterAccountBalance || amountGreaterCardRemainingBalance ) && immStep.get('amountisDirty');

        let minCardAmount = formatCurrency(AMAZON_GIFT_CARD_MIN_AMOUNT);
        let maxCardAmount = formatCurrency(AMAZON_GIFT_CARD_MAX_AMOUNT);

        let amountInstructionMessage = formatText('cardCharge-minMaxMessage', [
                formatAmount(minCardAmount),
                formatAmount(maxInputAmount)
            ]);

        let instructionsMessage = (
            <span>
                {amountInstructionMessage}
                <OKTooltip
                    content={formatText('buyAmazonGiftCardStep1-amountTooltip',[formatAmount(maxCardAmount)])}
                    placement="right"
                    offset={[15, 0]}
                />
            </span>
        );
        const giftVoucherAmount = immStep.get('giftVoucherAmount');
        const giftVoucherAmountObject = {
                amount: giftVoucherAmount,
                currency: currency
            };
        const formattedGiftVoucherAmount = (<OneLineSymbolAmount
            amountObject={giftVoucherAmountObject}
            amountObjectFormatted={currencyHelper.formatAmountObject(giftVoucherAmountObject, true)}
        />);
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <section className="accounts-buy-amazon-gift-card-step1">
                <div className="accounts-buy-amazon-gift-card-step1__subtitle">
                    <FormattedText
                        value="buyAmazonGiftCardStep1-subtitle"
                        injectedStrings={[promotionalPercentage]}
                    />
                </div>
                <section>
                    <h2 className="accounts-buy-amazon-gift-card-step1__title">
                        <FormattedText
                            value="buyAmazonGiftCardStep1-purchaseInformationTitle"
                        />
                    </h2>
                </section>
                <div className="accounts-buy-amazon-gift-card-step1__accounts-dropdown">
                    <DropdownAccounts
                        id="drd_AmazonGiftCardStep1_Origin"
                        label={formatText('buyAmazonGiftCardStep-accountLabel')}
                        immAccounts={immAccounts}
                        accountsIndexes={accountsIndexes}
                        currentAccountId={selectedAccount}
                        initialAccountId={selectedAccount}
                        onAccountChange={this.handleAccountFromChange}
                        error={accountDropdownError}
                        errorMsg={accountDropdownErrorMessage}
                        showAvailableBalance={true}
                        enabled={true}
                        tooltipMsg={tooltipMsgContent}
                        showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    />
                </div>

                <section className="clearfix">
                    <div className="accounts-buy-amazon-gift-card-step1__giftvoucher-input pull-left">
                        <label>
                            <AmountInput
                                id="inp_TransferStep1_Amount"
                                label={formatText('buyAmazonGiftCard-giftVoucherAmountLabel')}
                                callback={this.setChangedAmount}
                                min={AMAZON_GIFT_CARD_MIN_AMOUNT}
                                max={maxInputAmount}
                                maxFractionLength={AMAZON_GIFT_CARD_MAX_FRACTION_LENGTH}
                                maxIntegerLength={AMAZON_GIFT_CARD_MAX_INTEGER_LENGTH}
                                amount={immStep.get('amount')}
                                error={amountError}
                                errorMsg={amountErrorMessage}
                                language={language}
                                handleOnFocus={this.handleFocus}
                                hideFocusZero
                                instructionsMessage={instructionsMessage}
                            />
                        </label>
                        <span className="accounts-buy-amazon-gift-card-step1__currency">
                            {currency}
                        </span>
                    </div>
                    <div className="accounts-buy-amazon-gift-card-step1__amount pull-left">
                        <p className="accounts-buy-amazon-gift-card-step1__amount-label">
                            <FormattedText value="buyAmazonGiftCard-amountLabel" />
                        </p>
                        <p className="accounts-buy-amazon-gift-card-step1__amount-value">
                            {formattedGiftVoucherAmount}
                        </p>
                        <p className="accounts-buy-amazon-gift-card-step1__amount-info">
                            <FormattedText
                                value="buyAmazonGiftCardStep1-percentApplied"
                                injectedStrings={[promotionalPercentage]}
                            />
                        </p>
                    </div>
                </section>
                <div className="accounts-buy-amazon-gift-card-step1__email">
                    <label>
                        <FormattedText value="buyAmazonGiftCard-emailLabel" />
                        <OKTooltip
                            content="buyAmazonGiftCardStep1-emailTooltip"
                            placement="right"
                            offset={[15, 0]}
                        />
                    </label>
                    <p>{email}</p>
                </div>
                <div className="accounts-buy-amazon-gift-card-step1__disclaimer-text">
                    <OKMessage type="informative">
                        <FormattedText value="buyAmazonGiftCard-disclaimerText"
                        />
                    </OKMessage>
                </div>
                {__CONTACT_CENTER__ && this.buildPrecontractualMailInfo()}
            </section>
        );
    }
}

AccountsBuyAmazonGiftCardStep1.propTypes = {
    accountsIndexes: PropTypes.array.isRequired,
    amazonGiftCards: PropTypes.object,
    handleAgreementCheckboxChange: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immStep: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    initialAccount: PropTypes.object,
    promotionalPercentage: PropTypes.string,
    requestProfile: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAccount: PropTypes.func,
    setAccountAvailableBalance: PropTypes.func,
    setAmount: PropTypes.func,
    setGiftVoucherAmount: PropTypes.func,
}

module.exports = AccountsBuyAmazonGiftCardStep1;
